/**
 * Inner (authenticated) route path constants.
 *
 * Kept in a standalone module — separate from `routes/inner-routes.tsx`, which
 * imports every page component — so that consumers needing only a route path
 * do not transitively load the entire authenticated app graph.
 */
export const INNER_ROUTES = {
  // Home route
  HOME: '/home',
  // Balance route
  BALANCE: "/balance",
  TRANSFERS: "/transfers",
  SINGLE_TRANSFER: "/transfer/:id",
  // Transactions routes
  TRANSACTIONS: '/transactions',
  SINGLE_TRANSACTION: '/transaction/:id',
  // chargebacks routes
  CHARGE_BACKS: "/chargebacks",
  SINGLE_CHARGE_BACK: "/chargebacks/:id",
  // Orders routes
  ORDERS: '/orders',
  SINGLE_ORDER: '/order/:id',
  // Quick links routes
  QUICK_LINKS: '/quick-links',
  SINGLE_QUICK_LINK: '/quick-links/:id',
  // PayMe routes
  PAYME: "/payme",
  PAYME_SINGLE_TRANSACTION: "/payme/:id",
  PAYME_SETTINGS: "/payme/settings",
  // Reach routes
  CAMPAIGNS: "/reach/campaigns",
  SINGLE_CAMPAIGN: "/reach/campaign/:id",
  CAMPAIGN_ANALYSIS: "/reach/campaigns-analysis",
  BUNDLES: "/reach/bundles",
  // Reports route
  REPORTS: '/reports',
  // Risk Center routes
  RISK_CENTER: "/risk-center",
  SINGLE_RISK_ITEM: "/risk-center/:type/:id",
  // Terminals routes
  DEVICES: "/devices",
  BRANCHES: "/branches",
  SUMMARY: '/summary',
  // Settings routes
  SETTINGS: '/settings',
  // Profile Details route
  PROFILE_DETAILS: '/profile-details',
  CHANGE_PASSWORD: '/profile-details/change-password',
  // Business Profile route
  BUSINESS_PROFILE: '/business-profile',
  // User Management routes
  USER_AND_PERMISSIONS: '/user-and-permissions',
  MANAGE_ROLES: '/user-and-permissions/manage-roles',
  CREATE_NEW_ROLE: '/user-and-permissions/manage-roles/create-new-role',
  ROLE_DETAILS: '/user-and-permissions/manage-roles/role-details/:id',
  // Notifications route
  NOTIFICATIONS: '/notifications',
  // Checkout Customization route
  CHECKOUT_CUSTOMIZATION: "/settings/checkout-customization",
  // Services route 
  SERVICES: '/services',
  // Payment Integrations routes
  PAYMENT_INTEGRATIONS: '/payment-integrations',
  SINGLE_PAYMENT_INTEGRATION: '/payment-integration/:id',
  // API Keys route
  API_KEYS: '/settings/api-keys',
  // Iframes route
  IFRAMES: "/iframes",
  // Xero routes
  XERO: '/xero',
  // Payment Links routes
  BULK_PAYMENT_LINKS: "/bulk-payment-links",
  SINGLE_PAYMENT_LINK: "/single-payment-link",
  // Bills routes 
  BILLS: "/bills",
  // Single Bill route
  SINGLE_BILL: "/bills/:type/:id",
  // Pay Ads route
  PAY_ADS: "/bills/pay-ads",
  // Disputes routes
  DISPUTES: "/disputes",
  SINGLE_DISPUTE: "/dispute/:id",
};
